import React, {useState} from "react";
import Header from "../Sub/Header";
import Footer from "../Sub/Footer";
import MutualFund from '../Sub/MutualFund'
import MutualInvest from '../Sub/MutualInvest';
import MutualCalculator from '../Sub/MutualCalculator';
import MutualFundThemes from '../Sub/MutualFundThemes';
import WhyInvest from '../Sub/WhyInvest';
import CallBack from '../Sub/CallBack';
import FaqSection from "../Sub/FaqSection"
import LoginPop from '../Sub/LoginPop';


function Funds() {
  const [showLogin, setShowLogin] = useState(false);

const handleLoginClick = () => {
  setShowLogin(true);
};

const handleClosePop = () => {
  setShowLogin(false);
};
  return (
    <>
    <Header onLoginClick={handleLoginClick} />
     <MutualFund />
     <MutualInvest />
     <MutualCalculator />
     <MutualFundThemes />
     <WhyInvest />
     <CallBack />
     <FaqSection />
     {showLogin && <LoginPop onClose={handleClosePop} />}
     <Footer />

    </>
  )
}

export default Funds
